export var CheggBaseUrlProduction = 'https://www.chegg.com';
export var ProjectName = 'dropin-payments';
export var ORDER_SUCCESS = 'Order Placed successfully';
export var PLACE_ORDER_ATTEMPTED = 'Place Order Attempted';
// The version information will be filled by the webpack build.
// eslint-disable-next-line no-undef
export var SITE_ID_PROD = '4d504a8c7797';
export var SITE_ID_TEST = '60e8740d4be6';
export var CW_TEAM_NAME = 'CW';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/constants/AppConstants.js
// module id = 303
// module chunks = 11